export default __webpack_public_path__ + "static/media/icon_radiobutton_on.01e72a53.svg";